<template>
  <v-navigation-drawer
    v-resize="onResize"
    :value="drawer"
    :mini-variant.sync="mini"
    width="330"
    mini-variant-width="72"
    hide-overlay
    disable-resize-watcher
    permanent
    floating
    clipped
    fixed
    app
  >
    <v-list>
      <v-list-tile
        router-link
        @click="click_home"

        ripple>
        <v-list-tile-action>
          <v-icon >home</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>เมนูหลัก</v-list-tile-title>
      </v-list-tile>
      <v-list-group
        prepend-icon="announcement"
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>คู่มือการตอบปัญหา</v-list-tile-title>
        </v-list-tile>

        <v-list-group
          v-for="item in itemsformanual"
          :key="item.name"
          no-action
          sub-group
        >
          <v-list-tile slot="activator">
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-for="subItem in item.subitems"
            :key="subItem.title"
            router-link
            :to="typeof subItem.link === 'object'?subItem.link:{path: subItem.link}"
            no-action
          >
            <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      </v-list-group>

      <v-list-group
        v-for="(item, index) in items"
        :key="item.title"
        :prepend-icon="item.action"
        v-model="group[index]"
        no-action
      >
        <v-list-tile slot="activator" @click="mini = false">
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-for="subItem in item.subitems"
          :key="subItem.title"
          router-link
          :to="typeof subItem.link === 'object'?subItem.link:{path: subItem.link}"
        >
          <v-list-tile-content>
            <v-list-tile-sub-title
              v-html="subItem.title"
              style="color: rgba(0,0,0,.87);"
            ></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Navigation',
  props: {
    itemsformanual: {
      type: Array,
      default: _ => []
    },
    items: {
      type: Array,
      default: _ => []
    }
  },
  data () {
    return {
      drawer: true,
      group: [],
      mini: false,
      manual: false,
      click_home: _ => alert('Goto home')
    }
  },
  created () {
    this.onResize()
  },
  methods: {
    onResize () {
      const resize = () => {
        if (window.innerWidth <= 1024) return true
        if (window.innerWidth > 1024) return false
      }

      if (this.manual) return
      this.mini = resize()
    }
  }
}
</script>

<style>

</style>
